import React, { useState } from "react";
import styled from "styled-components";
import axios from "axios";
import { useRecoilState } from "recoil";
import { FormStyle } from "../../style/theme";
import { accountName, repoList, toastMessage } from "../../store";

const AccountForm = () => {
	const [name, setName] = useState("");
	const [account, setAccount] = useRecoilState(accountName);
	const [repo, setRepo] = useRecoilState(repoList);
	const [message, setMessage] = useRecoilState(toastMessage);

	const onSubmit = async (e: any) => {
		e.preventDefault();

		if (name === "") {
			setMessage("계정을 입력해주세요");
		} else {
			await axios
				.get(`https://api.github.com/users/${name}/repos`, {
					headers: {
						Accept: "application/vnd.github.nightshade-preview+json",
						// Authorization: `Token b6b4269b1...`,
					},
				})
				.then((el) => {
					setAccount(name);
					setRepo(el.data);
					setMessage("계정이 등록되었습니다");
				})
				.catch((err) => setMessage("올바른 계정을 입력해주세요"));
		}
	};

	return (
		<NameFormSection onSubmit={onSubmit}>
			<span>github.com/</span>
			<span className="point">&#123;</span>
			<input
				placeholder="GitHub Account"
				value={name}
				onChange={(e) => setName(e.target.value)}
			/>
			<span className="point">&#125;</span>
			<span>/</span>

			<button></button>
		</NameFormSection>
	);
};

const NameFormSection = styled.form`
	${FormStyle}
`;

export default AccountForm;
